<template>
    <transition-group name="slide-fade">
        <div class="donation-box" key="input">
            <div class="highlighted" v-html="this.$parent.locale.text_donation_description_highlight"></div>
            <div class="row">
                <div class="col-sm-6 col-md-6 col-lg-6" style="text-align: center;">
                    <img src="assets/img/supporting-families.png" style="width: 55%;"/>
                </div>
                <div class="col-sm-6 col-md-6 col-lg-6">
                    <div style="font-size: 15px;" v-html="this.$parent.locale.text_donation_description"></div>
                    <div style="text-align: center;" class="row">
                        <img src="https://www.kingscamps.org/wp-content/uploads/2024/12/FR-Fundraising-Badge-HR.png" width="40%">
                    </div>
                </div>
                <br>
                <div class="donation-footer" v-html="this.$parent.locale.text_donation_footer"></div>
            </div>
            <div class="donation-fields input">
                <div class="row">
                    <div class="col" v-for="option in predefinedOptions" :key="option">
                        <label class="col">
                            <input type="radio" name="donation" :value="`${option}`" v-model="selectedOption" @change="handleDonationSelection"/>
                            <span>£{{ option }}</span>
                        </label>
                    </div>
                    <div class="col">
                        <label class="col">
                            <input type="radio" name="donation" value="roundToNext5" v-model="selectedOption" @change="handleDonationSelection"/>
                            <span>Round to next £5 ( £{{ formatAmount(getDonationAmount(5, true)) }} )</span>
                        </label>
                    </div>
                    <div class="col">
                        <label class="col">
                            <input type="radio" name="donation" :value="28" v-model="selectedOption" @change="handleDonationSelection"/>
                            <span>£28 - Help subsidise a full day of camp for a child</span>
                        </label>
                    </div>
                    <!-- Custom Amount -->
                    <label class="col">
                        <input
                        type="radio"
                        name="donation"
                        value="custom"
                        v-model="selectedOption"
                        @change="handleDonationSelection"
                        />
                        Custom Amount
                    </label>
                    <input class="col-2" type="text" v-if="selectedOption === 'custom'" @keyup.enter="apply" id="donationInput" :placeholder="this.$parent.locale.text_donation_placeholder" name="donation" v-model="donation"/>
                </div>
                
                <h4>Selected Donation: £{{ formatAmount(donation) }}</h4>
                <div class="gift-aid-box" v-if="donation">
                    <h3>Gift Aid Declaration</h3>
                        <p>
                            By Gift Aiding your donation Kings Camps are able to claim an additional 25p per £1 donated, at no additional cost to you. 
                        </p>
                        <label>
                            <input type="radio" name="giftAid" value="1" v-model="giftAid" />
                            Yes - Please claim gift aid – I confirm my name and address details are correct
                        </label>
                        <br>
                        <label>
                            <input type="radio" name="giftAid" value="0" v-model="giftAid" />
                            No – I do not wish for you to claim gift aid
                        </label>
                        <div class="gift-aid-box-footer">
                            By clicking Yes I agree that I want to Gift Aid my donation to Kings Camps, part of Kings Active Foundation (registered charity1105460/ SCO43119). I am a UK taxpayer and understand that if I pay less Income Tax and/or Capital Gains Tax in the current tax year than the amount of Gift Aid claimed on all my donations it is my responsibility to pay any difference. Please email membership@kingscamps.org to correct any contact details. 
                        </div>
                </div>

                <div class="col-sm-12 col-md-6 col-lg-6">
                    <input type="submit" @click="apply" class="cta-button dark-blue" id="donationApply" :value="this.$parent.locale.button_donation_submit" />
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6">
                    <input type="submit" @click="applyNoDonation" class="cta-button red" id="donationApply" :value="this.$parent.locale.button_no_donation" />
                </div>

            </div>
        </div>
        <div class="box-layout-inner alert" key="alert" v-if="box.show">
            <div class="full-width" :class="box.colour">
                <span v-html="box.message"></span>
            </div>
        </div>
        <div class="box-layout-inner alert" key="alert" v-if="giftAidBox.show">
            <div class="full-width" :class="giftAidBox.colour">
                <span v-html="giftAidBox.message"></span>
            </div>
        </div>
    </transition-group>

</template>

<script>
    export default {
        data () {
            return {
                donation: '',
                predefinedOptions: [1, 2, 5, 10],
                selectedOption: null,
                customAmount: null,
                giftAid: "1",
                display: false,

                box: {
                    show: false,
                    colour: 'red',
                    message: "",
                },
                giftAidBox: {
                    show: false,
                    colour: 'yellow',
                    message: "",
                },
            }
        },
        props: [ 'booking_id', 'donation_amount', 'outstanding_balance'],
        created () {
            if (donation_amount == null) {
                this.donation = 0;
            }
            else {
                this.donation = donation_amount;
            }
        },
        methods: {
            apply: function () {
                //Only want to submit if there is a promo code entered
//                if(!this.promo)
//                    return false;
                if (this.donation === '' || this.donation === null) {
                    this.box = { show: true, message: this.$parent.locale.text_donation_required, colour: 'red'}
                }
                else {
                    // Check for Gift Aid selection
                    if (!this.giftAid) {
                        this.giftAidBox = { show: true, message: this.$parent.locale.text_giftaid_required, colour: 'red'}
                        return;
                    }
                    axios.post('camp-booking/bookings/' + this.booking_id + '/donation', {
                        donation_amount: this.donation,
                        gift_aid_option: this.giftAid
                    }).then(response => {
                        if(response.data.data.state == 'Invalid') {
                            //Handle invalid response here
                            this.box = { show: true, message: this.$parent.locale.text_donation_submit_failed, colour: 'red'}
                        } else if(response.data.data.state == 'Superseded') {
                            //Handle superseded response here
                            this.box = { show: true, message: this.$parent.locale.text_donation_submit_superseded, colour: 'red'}
                        } else {
                            //Handle valid response here
                            if (this.donation != 0) {
                                this.box = { show: true, message: this.$parent.locale.text_donation_submit_success, colour: 'green'}
                            }
                            else {
                                this.box = { show: true, message: this.$parent.locale.text_no_donation_submit_success, colour: 'green'}
                            }
                            this.$emit('addeddonation');
                        }

                        setTimeout(() => {
                            this.box = { show: false, message: '', colour: '' };
                            this.giftAidBox = { show: false, message: '', colour: '' };
                        }, 3000)
                    })
                }
            },
            applyNoDonation: function () {
                this.donation = 0;
                axios.post('camp-booking/bookings/' + this.booking_id + '/donation', {
                    donation_amount: 0,
                    gift_aid_option: '0'
                }).then(response => {
                    if(response.data.data.state == 'Invalid') {
                        //Handle invalid response here
                        this.box = { show: true, message: this.$parent.locale.text_donation_submit_failed, colour: 'red'}
                    } else if(response.data.data.state == 'Superseded') {
                        //Handle superseded response here
                        this.box = { show: true, message: this.$parent.locale.text_donation_submit_superseded, colour: 'red'}
                    } else {
                        //Handle valid response here
                        this.box = { show: true, message: this.$parent.locale.text_no_donation_submit_success, colour: 'green'}
                        this.$emit('addeddonation');
                    }

                    setTimeout(() => {
                        this.box = { show: false, message: '', colour: '' }
                    }, 3000)
                })
            },
            handleDonationSelection() {
                if (this.selectedOption === "custom") {
                    this.donation = this.customAmount || 0; // Set custom amount or default to 0
                } else if (this.selectedOption === "roundToNext5") {
                    this.donation = this.roundToTwoDigits(parseFloat(this.roundToNextBase(this.outstanding_balance || 0, 5) - this.outstanding_balance));
                } else {
                    this.donation = parseFloat(this.selectedOption);
                }
            },
            handleCustomAmountInput() {
                if (this.selectedOption === "custom") {
                    this.donation = this.customAmount || 0;
                }
            },
            roundToNext10(amount) {
                return Math.ceil(amount / 10) * 10;
            },
            roundToNextBase(amount, base) {
                // If amount is already a multiple of the base, return the next multiple
                if (amount % base === 0) {
                    return amount + base;
                }
                else {
                    return Math.ceil(amount / base) * base;
                }
            },
            roundToTwoDigits(amount) {
                const num = parseFloat(amount);
                return parseFloat(num.toFixed(2));
            },
            formatAmount(amount) {
                const num = parseFloat(amount);
                if (Number.isNaN(num)) return amount;
                return num.toFixed(2);
            },
            getDonationAmount(option, roundToNext = false) {
                if (roundToNext) {
                    return this.roundToTwoDigits(parseFloat(this.roundToNextBase(this.outstanding_balance || 0, option) - this.outstanding_balance));
                }
                return option;
            }
        },
    }
</script>



// WEBPACK FOOTER //
// BasketDonation.vue?0e88103e